import { sidebarMenuListItem, sidebarMenuListItemIcon, sidebarMenuListItemLabel, sidebarMenuListItemLink } from "@/layouts/AppLayout/Sidebar/Sidebar.css"
import { useGoogleConnectedStatus } from "./hooks/connect-gmail"
import { useDealSyncInvite, useDelSyncContacts, useDelSyncStatus } from "./hooks/deal-sync"
import Image from "next/image"
import styles from './styles/deal-sync.module.scss'
import { useState } from "react"
import { DealSyncSideBarModalSyncing } from "./SbModalSyncing"
import { DealSyncContactsModal } from "./DealSyncContactsModal"
import { DealSyncContact } from "./types/deal-sync"


export const DealSyncSidebarItem = () => {
  const { 
    data: dealSyncing, 
    isLoading: isDealSyncingLoading 
  } = useDelSyncStatus()
  const { 
    data: contacts,
    isLoading: isContactsLoading
  } = useDelSyncContacts()
  const { data, isLoading } = useGoogleConnectedStatus()
  const { mutateAsync, isLoading: invitingContacts } = useDealSyncInvite()
  const [modalSyncingOpen, setModalSyncingOpen] = useState(false)
  const [contactsModalOpen, setContactsModalOpen] = useState(false)
  const [contactsInvited, setContactsInvited] = useState(false)
  
  const isGoogleConnected = data?.gmailConnected
  const contactsCount = contacts?.length || 0
  const spinning = dealSyncing ||isDealSyncingLoading || isContactsLoading || isLoading

  const handleClick = () => {
    if (contactsCount === 0) {
      setModalSyncingOpen(true)
    } else {
      setContactsModalOpen(true)
    }
  }

  const handleInviteContacts = async (contacts: DealSyncContact[]) => {
    setContactsInvited(true)
    if (contacts.length === 0) {
      setContactsModalOpen(false)
      return
    }
    const emailsString = contacts.map((contact) => contact.contactEmail).join(',')
    await mutateAsync(emailsString)
    setContactsInvited(true)
  }

  const closeContactsModal = () => {
    setContactsModalOpen(false)
    setContactsInvited(false)
  }

  if (!isGoogleConnected || isLoading) return null

  return (
    <>
      <DealSyncSideBarModalSyncing
        isOpen={modalSyncingOpen}
        onClose={() => setModalSyncingOpen(false)}
      />
      <DealSyncContactsModal
        contacts={contacts}
        isOpen={contactsModalOpen}
        onClose={closeContactsModal}
        onInvite={handleInviteContacts}
        isLoading={invitingContacts}
        contactsInvited={contactsInvited}
      />
      <li
        className={sidebarMenuListItem}
        onClick={handleClick}
      >
        <div className={sidebarMenuListItemLink}>
          <span className={sidebarMenuListItemIcon}>
            🏆
          </span>
          <span className={sidebarMenuListItemLabel}>
            VIP Connections
          </span>
          {contactsCount > 0 ? (
            <div className={styles.numberOfContacts}>
              {contactsCount}
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <Image
                src="/assets/coin-icon.svg"
                alt="Loading"
                width={16}
                height={16}
                className={spinning ? styles.spin : ''}
              />
            </div>
          )}
        </div>
      </li>
    </>
  )
}